import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid';

import SupportImg from '../assets/customer-service.jpg';
import { useContactEmail } from '../utilities/useContactEmail';

export default function Contact() {
  const { contactEmail } = useContactEmail();

  return (
    <div className="flex flex-col">
      <div className="mx-auto sm:w-full md:max-w-7xl md:px-0 md:pb-40 md:pt-20 ">
        <div className="mx-auto w-full sm:px-6 lg:px-8">
          <div className="flex flex-col items-center gap-8 overflow-hidden bg-primaryDarkBlue px-5 py-24 shadow-2xl sm:rounded-3xl md:px-10 lg:flex-row xl:py-32">
            <div className="sm:w-full lg:w-1/2">
              <h2 className="max-w-2xl text-3xl font-bold tracking-tight text-white sm:text-4xl">
                Support - Available 24/7, 365 days
              </h2>
              <hr className="my-8 h-1 w-48 border-0 bg-accentGreen"></hr>
              <p className="mt-4 text-lg font-semibold leading-8 text-gray-300">
                Need to chat to a live person?
              </p>
              <p className="mt-0 text-base leading-8 text-gray-400">
                Call or send us a message and our agents will be in touch.
              </p>
              <div className="mt-4 flex flex-row items-center gap-2">
                <PhoneIcon
                  className="size-5 flex-none text-accentGreen"
                  aria-hidden="true"
                />
                <div className="flex flex-row gap-2">
                  <a href="tel:8306098855" className="text-lg text-gray-200">
                    (830) 609-8855
                  </a>
                </div>
              </div>
              <div className="mt-4 flex flex-row items-center gap-2">
                <EnvelopeIcon
                  className="size-5 flex-none text-accentGreen"
                  aria-hidden="true"
                />
                <div className="flex flex-row gap-2">
                  <a
                    href={`mailto:${contactEmail}`}
                    className="text-lg text-gray-200"
                  >
                    {contactEmail}
                  </a>
                </div>
              </div>
            </div>
            <img
              src={SupportImg}
              alt="Support"
              className="w-full rounded-2xl lg:w-1/2"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
